import React, { useState, useEffect } from "react";
import { Card } from 'react-bootstrap';
import { apiClient } from '../api/ApiClient';
import { jwtDecode } from 'jwt-decode';
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";

const ProfileManagePhotosComponent = () => {
    const [photos, setPhotos] = useState([]);
    const [photoCount, setPhotoCount] = useState(0);
    const [memberTypeId, setMemberTypeId] = useState('1');

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const decoded = jwtDecode(token);
            setMemberTypeId(decoded.memberTypeId);
        }
        fetchPhotos();
        fetchPhotosCount();
    }, []);

    const fetchPhotos = async () => {
      try {
          const response = await apiClient.get('/rest/profile/photos');
          console.log('Photos response:', response.data);
          if (response.data && Array.isArray(response.data)) {
              // Handle the array response where each item is [imagePath, imageId]
              const formattedPhotos = response.data.map(photo => ({
                  PHOTOS_ID: photo[3], // Adjust index based on your actual data
                  IMAGE_PATH: photo[1],
                  MEMBER_IMAGE_NAME: photo[0],
                  IMAGE_PRIMARY: photo[2] || 'N' // Adjust index based on your data
              }));
              setPhotos(formattedPhotos);
          }
      } catch (error) {
          console.error('Error fetching photos:', error);
      }
  };

  const fetchPhotosCount = async () => {
      try {
          const response = await apiClient.get('/rest/profile/PhotosCount');
          console.log('Photo count response:', response.data);
          if (response.data && response.data.photos) {
              // Based on your response showing { photos: { PHOTO_COUNT: 1 } }
              setPhotoCount(response.data.photos.PHOTO_COUNT);
          }
      } catch (error) {
          console.error('Error fetching photos count:', error);
      }
  };

    

    const setPrimaryPhoto = async (photoId) => {
        try {
            // Convert photoId to a number if it's not already
            const numericPhotoId = typeof photoId === 'number' ? photoId : Number(photoId);
            
            if (isNaN(numericPhotoId)) {
                console.error("Invalid photo ID:", photoId);
                return;
            }
            
            console.log("Primary photo with ID:", numericPhotoId);
            
            await apiClient.post('/rest/photos/profilePhotosPrimary', { 
                photoIds: [numericPhotoId]  // Send as number in an array
            });
            
            fetchPhotos();
        } catch (error) {
            console.error('Error Primary photo:', error);
        }
      };


    const deletePhoto = async (photoId) => {
        try {
            // Convert photoId to a number if it's not already
            const numericPhotoId = typeof photoId === 'number' ? photoId : Number(photoId);
            
            if (isNaN(numericPhotoId)) {
                console.error("Invalid photo ID:", photoId);
                return;
            }
            
            console.log("Deleting photo with ID:", numericPhotoId);
            
            await apiClient.post('/rest/photos/profilePhotosDelete', { 
                photoIds: [numericPhotoId]  // Send as number in an array
            });
            
            fetchPhotos();
        } catch (error) {
            console.error('Error deleting photo:', error);
        }
      };

      
    const deletePhotoBack = async (photoId) => {
      try {
          await apiClient.post('rest/photos/profilePhotosDelete', { 
            photoIds: [photoId]  // Wrap the single ID in an array
          });
          fetchPhotos();
      } catch (error) {
          console.error('Error deleting photo:', error);
      }
  };

    return (
        <div className="container-1024">
            <div className="results-area">
                <h3>My Photos</h3>
                <div className="results-content">
                    <div className="results-center-details">
                        <div className="photo-count-message mb-4">
                            <b>You have {photoCount} uploaded pictures of {memberTypeId === '1' ? '10' : '20'} Picture limit for {memberTypeId === '1' ? 'free' : 'upgraded'} members.</b>
                        </div>
                        
                        <div className="container d-flex flex-wrap justify-content-left">
                            {photos.map((photo, index) => (
                                <Card key={index} className="favorite-card">
                                    <Card.Img
                                        variant="top"
                                        src={`https://pics.netfixup.com/${photo.IMAGE_PATH}${photo.MEMBER_IMAGE_NAME}`}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = 'https://pics.netfixup.com/nfu_default_img/addNewUserPhoto.jpg';
                                        }}
                                    />
                                    <Card.Body className="d-flex flex-column gap-2">
                                        {photo.IMAGE_PRIMARY === 'Y' ? (
                                            <Button 
                                                variant="success" 
                                                className="w-100" 
                                                disabled
                                            >
                                                This is my primary photo
                                            </Button>
                                        ) : (
                                            <>
                                                <Button 
                                                    variant="success" 
                                                    onClick={() => setPrimaryPhoto(photo.PHOTOS_ID)}
                                                    className="w-100"
                                                >
                                                    Set primary photo
                                                </Button>
                                                <Button 
                                                    variant="danger" 
                                                    onClick={() => deletePhoto(photo.PHOTOS_ID)}
                                                    className="w-100"
                                                >
                                                    Delete photo below
                                                </Button>
                                            </>
                                        )}
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    </div>
                    
                    {/* Right sidebar - you can keep this if needed */}
                    <div className="results-right-sidebar">
                        <h5>Other Photos</h5>
                        {/* Add any sidebar content here */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileManagePhotosComponent;